import React, { useState } from "react";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  Typography,
  TableRow,
  TextField,
  Dialog,
  Box,
  Select,
  MenuItem,
  FormControl,
  AppBar,
  Toolbar,
  Slide,
  Grid,
  DialogActions,
} from "@mui/material";
import { EditNote, DeleteForever, AddCircle } from "@mui/icons-material";
import Swal from "sweetalert2";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const FooterSettings = () => {
  const [links, setLinks] = useState([
    { id: 1, title: "Link 1", description: "Description 1", status: "Active" },
    {
      id: 2,
      title: "Link 2",
      description: "Description 2",
      status: "Inactive",
    },
    { id: 3, title: "Link 3", description: "Description 3", status: "Active" },
  ]);
  const [open, setOpen] = useState(false);
  const [selectedLink, setSelectedLink] = useState(null); // Will hold the link being edited
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [status, setStatus] = useState("Active");

  const handleOpen = (link = null) => {
    if (link) {
      setSelectedLink(link);
      setTitle(link.title);
      setDescription(link.description);
      setStatus(link.status);
    } else {
      setSelectedLink(null);
      setTitle("");
      setDescription("");
      setStatus("Active");
    }
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = () => {
    if (selectedLink) {
      // Update the selected link
      setLinks(
        links.map((link) =>
          link.id === selectedLink.id
            ? { ...link, title, description, status }
            : link
        )
      );
    } else {
      // Add a new link
      const newLink = { id: Date.now(), title, description, status };
      setLinks([...links, newLink]);
    }
    handleClose();
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Yes, remove it!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        setLinks(links.filter((link) => link.id !== id));
        Swal.fire("Deleted!", "The link has been deleted.", "success");
      }
    });
  };

  // const handleStatusChange = (id, status) => {
  //   setLinks(
  //     links.map((link) => (link.id === id ? { ...link, status } : link))
  //   );
  // };

  return (
    <div
      style={{
        padding: "20px",
        backgroundColor: "white",
        color: "black",
        borderRadius: "10px",
      }}
    >
      {/* Add Footer Link Button */}
      <Button
        variant="contained"
        onClick={() => handleOpen()}
        sx={{
          backgroundColor: "#1d82f5",
          color: "white",
          padding: "5px",
          "&:hover": { backgroundColor: "orange" },
        }}
      >
        <Typography
          variant="h6"
          component="h2"
          gutterBottom
          style={{
            color: "white",
            marginTop: 3,
            display: "flex",
            alignItems: "center",
          }}
        >
          <AddCircle style={{ marginRight: 5 }} />
          Add Footer Link
        </Typography>
      </Button>

      {/* Footer Links Table */}
      <TableContainer style={{ color: "black" }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell style={{ color: "black" }}>Title</TableCell>
              <TableCell style={{ color: "black", paddingRight: "100px"   }}>Description</TableCell>
              <TableCell style={{ color: "black",paddingLeft:"250px"  }}>Status</TableCell>
              <TableCell style={{ color: "black" ,paddingLeft:"90px" }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {links.map((link) => (
              <TableRow key={link.id}>
                <TableCell style={{ color: "black" }}>{link.title}</TableCell>
                <TableCell style={{ color: "black", paddingRight: "100px"  }}>
                  {link.description}
                </TableCell>
                <TableCell style={{ color: "black",paddingLeft:"200px" }}>
                <FormControl 
                 fullWidth
                    sx={{
                    mt: 1,
                    '& .MuiOutlinedInput-root': {
                        '& fieldset': { borderColor: '#d9d9d9' },
                        '&:hover fieldset': { borderColor: 'black' },
                        '&.Mui-focused fieldset': { borderColor: 'black' },
                        color:"black"
                    },
                    }}
                 >
                    {/* <InputLabel>Status</InputLabel> */}
                    <Select
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                    >
                    <MenuItem value="Active">Active</MenuItem>
                    <MenuItem value="Inactive">Inactive</MenuItem>
                    </Select>
                </FormControl> 
                </TableCell>
                <TableCell>
                  <Button
                    onClick={() => handleOpen(link)}
                    variant="outlined"
                    style={{ marginRight: "10px" }}
                  >
                    <EditNote /> Edit
                  </Button>
                  <Button
                    onClick={() => handleDelete(link.id)}
                    variant="outlined"
                  >
                    <DeleteForever /> Delete
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Modal for Editing / Adding Footer Link */}
      <Dialog
        fullWidth
        maxWidth="sm"
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
        PaperProps={{
          style: {
            position: "absolute",
            background: "#fff",
            top: "0",
            backgroundColor: "white",
            maxHeight: "95%",
            margin: "auto",
            overflowX: "hidden",
            zIndex: 1200,
          },
        }}
      >
        <AppBar sx={{ position: "relative", bgcolor: "#1d82f5" }}>
          <Toolbar>
            <Typography sx={{ ml: 2, flex: 1, fontSize: "18px" }}>
              {selectedLink ? "Edit Footer Link" : "Add Footer Link"}
            </Typography>
          </Toolbar>
        </AppBar>

        <Box sx={{ bgcolor: "white", mt: 3, p: 4 }}>
          {/* Title and Status Fields in One Row */}
          <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
            {/* Title Field */}
            <Box sx={{ width: "50%" }}>
              <label style={{ fontSize: "14px", color: "#333" }}>Title</label>
              <TextField
                placeholder="Title"
                fullWidth
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                sx={{
                  mt: 1,
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": { borderColor: "#d9d9d9" },
                    "&:hover fieldset": { borderColor: "black" },
                    "&.Mui-focused fieldset": { borderColor: "black" },
                    color:"black"
                  },
                }}
              />
            </Box>

            {/* Status Field */}
            <Box sx={{ width: "50%" }}>
                <label style={{ fontSize: "14px", color: "#333" }}>Status</label>
                <FormControl 
                 fullWidth
                    sx={{
                    mt: 1,
                    '& .MuiOutlinedInput-root': {
                        '& fieldset': { borderColor: '#d9d9d9' },
                        '&:hover fieldset': { borderColor: 'black' },
                        '&.Mui-focused fieldset': { borderColor: 'black' },
                        color:"black"
                    },
                    }}
                 >
                    {/* <InputLabel>Status</InputLabel> */}
                    <Select
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                    >
                    <MenuItem value="Active">Active</MenuItem>
                    <MenuItem value="Inactive">Inactive</MenuItem>
                    </Select>
                </FormControl>
            </Box>

          </Box>

          {/* Description Field */}
          <Box sx={{ mb: 2 }}>
            <label style={{ fontSize: "14px", color: "#333" }}>
              Description
            </label>
            <TextField
            //   label="Description"
            //   variant="outlined"
              fullWidth
              placeholder="Description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              sx={{
                mt: 1,
                "& .MuiOutlinedInput-root": {
                  "& fieldset": { borderColor: "#d9d9d9" },
                  "&:hover fieldset": { borderColor: "black" },
                  "&.Mui-focused fieldset": { borderColor: "black" },
                  color:"black"
                },
              }}
            />
          </Box>

        {/* DialogActions */}
        <DialogActions> 
            <Grid container sx={{ padding: "10px 0 20px 0" ,flex:'row'}}>
                <Grid item sx={11} className="messageFooter">
                {/* Save Button */}
                <Box
                    className="response"
                    onClick={handleSubmit}
                    sx={{
                    display: "inline-block",
                    padding: "8px 16px",
                    backgroundColor: "#1d82f5",
                    color: "white",
                    borderRadius: "4px",
                    cursor: "pointer",
                    '&:hover': {
                        backgroundColor: 'orange',
                    }
                    }}
                >
                    Save
                </Box>

                {/* Cancel Button */}
                <Box
                    className="cancel"
                    onClick={handleClose}
                    sx={{
                    display: "inline-block",
                    padding: "8px 16px",
                    color: "black",
                    borderRadius: "4px",
                    cursor: "pointer",
                    '&:hover': {
                        backgroundColor: 'orange',
                    },
                    }}
                >
                    Cancel
                </Box>
                </Grid>
            </Grid>
        </DialogActions>


        </Box>
      </Dialog>
    </div>
  );
};

export default FooterSettings;
